import { NgModule, ModuleWithProviders, ErrorHandler } from "@angular/core";
import { CommonModule, DecimalPipe} from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinnerModule, MatInputModule, MatDialogModule } from "@angular/material";
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { NgxPermissionsModule } from "ngx-permissions";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatIconModule } from "@angular/material/icon";
import {MatRadioModule} from '@angular/material/radio';
import { NgxPaginationModule } from "ngx-pagination";
import {
  LoaderComponent,
  WidgetRegionwiseOtifBreakupComponent,
  WidgetReturnEndToEndSlaComponent,
  WidgetReturnReasonForFailureComponent,
  WidgetInwardWorstODPairsComponent,
  WidgetRegionWiseDetailComponent,
  WidgetOrderDistributionComponent,
  WidgetInwardReasonForFailureComponent,
  WidgetInwardEndToEndSlaComponent,
  WidgetDeliveryEndToEndSlaComponent,
  WidgetInwardEndToEndSlaTrendComponent,
  WidgetTransferWorstODPairsComponent,
  WidgetPerformanceDashboardEndToEndSlaComponent,
  WidgetTransportationWorstODPairsComponent,
  WidgetTransportationWarehouseUtilizationComponent,
  WidgetTransportationNuclearStockpilesComponent,
  WidgetTransportationTemperatureAdherenceComponent,
  DateRangeFilterComponent,
  DropDownFilterComponent,
  FilterWrapperComponent,
  AutocompleteComponent,
  PaginationComponent,
  GenericDialogBoxComponent,
  WidgetOverallCumulativeStatusComponent,
  WidgetStatusRigionwiseStatusComponent,
  WidgetStatusBreakupComponent,
  WidgetStatusPieBreakupComponent,
  TabDivComponent,
  ToggleToSwitchComponent
} from "./components/";
import { MatSortModule } from "@angular/material";
import { MatTableModule } from "@angular/material/table";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { CdkTableModule } from "@angular/cdk/table";
import { RouterModule, Routes } from "@angular/router";
import { MenuSearchBarComponent } from "./components/menu-search-bar/menu-search-bar.component";
// import { GlobalErrorHandler } from "./error-handler/global-error-handler";
import {
  ErrorService,
  LoggingService,
  LocalStorageService,
  HttpConfigInterceptor,
  MessageService
} from "./services";
import { HighlightComponent } from "./components/highlight/highlight.component";
import { GraphWidgetComponent } from "./components/graph-widget/graph-widget.component";
import { WidgetOverallOtifComponent } from "./components/widgets/widget-overall-otif/widget-overall-otif.component";
import {
  WidgetMostAffectedStatesComponent,
  WidgetMostAffectedCustomersComponent,
  WidgetReturnWorstODPairsComponent,
  WidgetReturnEndToEndSlaTrendComponent,
  WidgetWarehouseMostAffectedWarehousesComponent,
  WidgetDamageStorageComponent,
  WidgetWarehouseUtilizationComponent,
  WidgetInventoryAuditAccuracyComponent,
  ShowPagesComponent,
  WidgetOverallStatusTrendComponent,
  WidgetSlaGraphComponent
} from "./components";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { WidgetOtifTrendsComponent } from "./components/widgets/widget-otif-trends/widget-otif-trends.component";
import { WidgetDeliveryReasonForFailureComponent } from "./components/widgets/widget-delivery-reason-for-failure/widget-delivery-reason-for-failure.component";
import { WidgetTransferEndToEndSlaComponent } from "./components/widgets/widget-transfer-end-to-end-sla/widget-transfer-end-to-end-sla.component";
import { WidgetTransferEndToEndSlaTrendComponent } from "./components/widgets/widget-transfer-end-to-end-sla-trend/widget-transfer-end-to-end-sla-trend.component";
import { WidgetTransferReasonForFailureComponent } from "./components/widgets/widget-transfer-reason-for-failure/widget-transfer-reason-for-failure.component";
import { WidgetWarehouseSlaComponent } from "./components/widgets/widget-warehouse-sla/widget-warehouse-sla.component";
import { WidgetOverallTemperatureAdheranceComponent } from "./components/widgets/widget-overall-temperature-adherance/widget-overall-temperature-adherance.component";
import { GenericHttpService } from "./services/generic-http.service";
import { HighchartsChartModule } from "highcharts-angular";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxOrPermissionDirective } from "./directives/ngxOrPermissions.directive";
import { WidgetWpSlaTrendComponent } from "./components/widgets/widget-wp-sla-trend/widget-wp-sla-trend.component";
import { WidgetTpSlaTrendComponent } from "./components/widgets/widget-tp-sla-trend/widget-tp-sla-trend.component";
import { WidgetECommerceComponent } from "./components/widgets/widget-e-commerce/widget-e-commerce.component";
import { PermissionUrlService } from "./services/permissions.service";
import { PermissionGuardService } from "./services/permission-guard.service";
import { DropDownService } from "./components/filters/drop-down/services/drop-down.service";
import { FilterWrapperService } from "./components/filters/services/filter-wrapper.service";
import { CommonService } from "./services/common.service";
import { GenericUtils } from "./utilities";
import { SwapMultiselectListComponent } from './components/swap-multiselect-list/swap-multiselect-list.component';
import { WidgetWarehouseDamageComponent } from "./components/widgets/widget-warehouse-damage/widget-warehouse-damage.component";
import { WidgetLoaderComponent } from "./components/widget-loader/widget-loader.component";
import { TypeTextComponent } from "./components/filters/type-text/type-text.component";
import { ClickOutsideDirective } from "./directives/click-out-side.directive";
import { HighlightWrapperComponent } from "./components/highlights/highlight-wrapper/highlight-wrapper.component";
import { MobileFiltersWrapperComponent } from "./components/mobile-filters/mobile-filters-wrapper/mobile-filters-wrapper.component";

import * as Highcharts from "highcharts";
import { MobileDropDownComponent } from './components/mobile-filters/mobile-drop-down/mobile-drop-down.component';
import { MobileDateRangeComponent } from './components/mobile-filters/mobile-date-range/mobile-date-range.component';
import { MobileTextFieldComponent } from './components/mobile-filters/mobile-text-field/mobile-text-field.component';
import { MobileAutoCompleteComponent } from './components/mobile-filters/mobile-auto-complete/mobile-auto-complete.component';
import { MobileLabelsComponent } from './components/mobile-filters/mobile-labels/mobile-labels.component';
import { OrderStatusHighlightComponent } from "./components/highlights/order-status-highlight/order-status-highlight.component";
import { MatButtonModule } from '@angular/material/button';

import { WidgetWrapperComponent } from './components/widget-wrapper/widget-wrapper.component';
import { WidgetPieChartComponent } from './components/widget-wrapper/widget-pie-chart/widget-pie-chart.component';
import { WidgetLoaderErrorHandlerComponent } from './components/widget-loader-error-handler/widget-loader-error-handler.component';
import { WidgetLineChartComponent } from './components/widget-wrapper/widget-line-chart/widget-line-chart.component';
import { WidgetSimpleTableComponent } from './components/widget-wrapper/widget-simple-table/widget-simple-table.component';
import { DynamicPipe } from './directives/dynamic.pipe';
import { WidgetDualColumnChartComponent } from './components/widget-wrapper/widget-dual-column-chart/widget-dual-column-chart.component';
import { WidgetAreaChartComponent } from './components/widget-wrapper/widget-area-chart/widget-area-chart.component';
import { WidgetStackedColumnChartComponent } from './components/widget-wrapper/widget-stacked-column-chart/widget-stacked-column-chart.component';
import { WidgetWaterfallChartComponent } from './components/widget-wrapper/widget-waterfall-chart/widget-waterfall-chart.component';
import { WidgetTableOrderDistributionComponent } from './components/widget-wrapper/widget-table-order-distribution/widget-table-order-distribution.component';
import { WidgetSimpleColumnChartComponent } from './components/widget-wrapper/widget-simple-column-chart/widget-simple-column-chart.component';
import { WidgetMultiColumnColumnChartComponent } from './components/widget-wrapper/widget-multi-column-column-chart/widget-multi-column-column-chart.component';
import { WidgetLineChartWithControlsComponent } from './components/widget-wrapper/widget-line-chart-with-controls/widget-line-chart-with-controls.component';
import { SingleApiHighlightsComponent } from './components/single-api-highlights/single-api-highlights.component';
import { HighlightBlockComponent } from './components/single-api-highlights/highlight-block/highlight-block.component';
import { WidgetLineChartOverviewComponent } from './components/widget-wrapper/widget-line-chart-overview/widget-line-chart-overview.component';
import { WhpHighlightWrapperComponent } from './components/highlights/whp-highlight-wrapper/whp-highlight-wrapper.component';
import { InventoryHighlightComponent } from './components/highlights/whp-highlight-wrapper/inventory-highlight/inventory-highlight.component';
import { ShowAllTableDialogComponent } from './components/widget-wrapper/widget-simple-table/dialogs/show-all-table-dialog/show-all-table-dialog.component';
import { StackColumnChartWithLinesComponent } from './components/widget-wrapper/stack-column-chart-with-lines/stack-column-chart-with-lines.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TransportationHighlightWrapperComponent } from './components/highlights/transportation-highlight-wrapper/transportation-highlight-wrapper.component';
import { TransportationHighlightsComponent } from './components/highlights/transportation-highlight-wrapper/transportation-highlights/transportation-highlights.component'
import { AmountIndianUnit } from "./pipes/amount-indian-unit.pipe";


Highcharts.setOptions({
  lang: {
    thousandsSep: ","
  }
});
@NgModule({
  imports: [
    MatSortModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatInputModule,
    RouterModule,
    HighchartsChartModule,
    NgSelectModule,
    TranslateModule,
    MatTableModule,
    CdkTableModule,
    NgxPaginationModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    NgxPermissionsModule,
    NgxDaterangepickerMd.forRoot(),
    MatDialogModule,
    MatButtonModule,
    NgScrollbarModule
  ],
  declarations: [
    NgxOrPermissionDirective,
    LoaderComponent,
    MenuSearchBarComponent,
    HighlightComponent,
    GraphWidgetComponent,
    WidgetOverallOtifComponent,
    WidgetOtifTrendsComponent,
    WidgetMostAffectedStatesComponent,
    WidgetMostAffectedCustomersComponent,
    WidgetRegionwiseOtifBreakupComponent,
    WidgetDeliveryReasonForFailureComponent,
    WidgetTransferEndToEndSlaComponent,
    WidgetTransferEndToEndSlaTrendComponent,
    WidgetTransferReasonForFailureComponent,
    WidgetReturnEndToEndSlaComponent,
    WidgetReturnReasonForFailureComponent,
    WidgetReturnWorstODPairsComponent,
    WidgetReturnEndToEndSlaTrendComponent,
    WidgetInwardWorstODPairsComponent,
    WidgetRegionWiseDetailComponent,
    WidgetOrderDistributionComponent,
    WidgetInwardReasonForFailureComponent,
    WidgetInwardEndToEndSlaComponent,
    WidgetDeliveryEndToEndSlaComponent,
    WidgetInwardEndToEndSlaTrendComponent,
    WidgetTransferWorstODPairsComponent,
    WidgetPerformanceDashboardEndToEndSlaComponent,
    WidgetWarehouseMostAffectedWarehousesComponent,
    WidgetWarehouseUtilizationComponent,
    WidgetDamageStorageComponent,
    WidgetInventoryAuditAccuracyComponent,
    WidgetTransportationWorstODPairsComponent,
    WidgetTransportationWarehouseUtilizationComponent,
    WidgetTransportationNuclearStockpilesComponent,
    WidgetTransportationTemperatureAdherenceComponent,
    WidgetWpSlaTrendComponent,
    WidgetTpSlaTrendComponent,
    WidgetWarehouseSlaComponent,
    WidgetOverallTemperatureAdheranceComponent,
    WidgetDamageStorageComponent,
    WidgetECommerceComponent,
    DateRangeFilterComponent,
    DropDownFilterComponent,
    FilterWrapperComponent,
    WidgetWarehouseDamageComponent,
    WidgetECommerceComponent,
    WidgetLoaderComponent,
    TypeTextComponent,
    ClickOutsideDirective,
    AutocompleteComponent,
    PaginationComponent,
    ShowPagesComponent,
    HighlightWrapperComponent,
    GenericDialogBoxComponent,
    TabDivComponent,
    WidgetWrapperComponent,
    WidgetPieChartComponent,
    WidgetLoaderErrorHandlerComponent,
    WidgetLineChartComponent,
    WidgetSimpleTableComponent,
    DynamicPipe,
    WidgetDualColumnChartComponent,
    WidgetAreaChartComponent,
    WidgetStackedColumnChartComponent,
    MobileFiltersWrapperComponent,
    MobileDropDownComponent,
    MobileDateRangeComponent,
    MobileTextFieldComponent,
    MobileAutoCompleteComponent,
    MobileLabelsComponent,
    WidgetOverallStatusTrendComponent,
    WidgetOverallCumulativeStatusComponent,
    OrderStatusHighlightComponent,
    WidgetStatusRigionwiseStatusComponent,
    WidgetStatusBreakupComponent,
    WidgetStatusPieBreakupComponent,
    ToggleToSwitchComponent,
    SwapMultiselectListComponent,
    WidgetWaterfallChartComponent,
    WidgetTableOrderDistributionComponent,
    WidgetLineChartOverviewComponent,
    StackColumnChartWithLinesComponent,
    TransportationHighlightWrapperComponent,
    TransportationHighlightsComponent,
    WidgetSimpleColumnChartComponent,
    WidgetMultiColumnColumnChartComponent,
    WidgetLineChartWithControlsComponent,
    SingleApiHighlightsComponent,
    HighlightBlockComponent,
    WhpHighlightWrapperComponent,
    InventoryHighlightComponent,
    ShowAllTableDialogComponent,
    WidgetSlaGraphComponent,
    AmountIndianUnit
    
  ],
  entryComponents: [GenericDialogBoxComponent, ShowAllTableDialogComponent],
  exports: [
    NgxPermissionsModule,
    NgxPaginationModule,
    NgxDaterangepickerMd,
    MatInputModule,
    NgSelectModule,
    LoaderComponent,
    MenuSearchBarComponent,
    HighlightComponent,
    GraphWidgetComponent,
    WidgetOverallOtifComponent,
    WidgetMostAffectedStatesComponent,
    WidgetRegionwiseOtifBreakupComponent,
    WidgetMostAffectedCustomersComponent,
    WidgetDeliveryReasonForFailureComponent,
    WidgetOtifTrendsComponent,
    WidgetTransferEndToEndSlaComponent,
    WidgetTransferEndToEndSlaTrendComponent,
    WidgetTransferReasonForFailureComponent,
    WidgetReturnEndToEndSlaComponent,
    WidgetReturnReasonForFailureComponent,
    WidgetReturnWorstODPairsComponent,
    WidgetReturnEndToEndSlaTrendComponent,
    WidgetInwardWorstODPairsComponent,
    WidgetRegionWiseDetailComponent,
    WidgetOrderDistributionComponent,
    WidgetInwardReasonForFailureComponent,
    WidgetInwardEndToEndSlaComponent,
    WidgetDeliveryEndToEndSlaComponent,
    WidgetInwardEndToEndSlaTrendComponent,
    WidgetTransferWorstODPairsComponent,
    WidgetPerformanceDashboardEndToEndSlaComponent,
    WidgetTransportationWorstODPairsComponent,
    WidgetTransportationWarehouseUtilizationComponent,
    WidgetTransportationNuclearStockpilesComponent,
    WidgetTransportationTemperatureAdherenceComponent,
    WidgetWpSlaTrendComponent,
    WidgetTpSlaTrendComponent,
    WidgetWarehouseSlaComponent,
    WidgetOverallTemperatureAdheranceComponent,
    WidgetECommerceComponent,
    WidgetWarehouseMostAffectedWarehousesComponent,
    WidgetWarehouseUtilizationComponent,
    WidgetDamageStorageComponent,
    WidgetECommerceComponent,
    NgxOrPermissionDirective,
    DateRangeFilterComponent,
    DropDownFilterComponent,
    FilterWrapperComponent,
    WidgetWarehouseDamageComponent,
    WidgetInventoryAuditAccuracyComponent,
    WidgetLoaderComponent,
    WidgetStatusRigionwiseStatusComponent,
    WidgetStatusBreakupComponent,
    TypeTextComponent,
    ClickOutsideDirective,
    AutocompleteComponent,
    PaginationComponent,
    ShowPagesComponent,
    HighlightWrapperComponent,
    GenericDialogBoxComponent,
    TabDivComponent,
    WidgetPieChartComponent,
    WidgetLoaderErrorHandlerComponent,
    WidgetLineChartComponent,
    WidgetSimpleTableComponent,
    WidgetDualColumnChartComponent,
    WidgetAreaChartComponent,
    WidgetStackedColumnChartComponent,
    WidgetWrapperComponent,
    MobileFiltersWrapperComponent,
    WidgetWaterfallChartComponent,
    WidgetOverallStatusTrendComponent,
    WidgetOverallCumulativeStatusComponent,
    WidgetTableOrderDistributionComponent,
    OrderStatusHighlightComponent,
    WidgetStatusPieBreakupComponent,
    ToggleToSwitchComponent,
    SwapMultiselectListComponent,
    NgScrollbarModule,
    WidgetLineChartOverviewComponent,
    WidgetMultiColumnColumnChartComponent,
    WidgetLineChartWithControlsComponent,
    StackColumnChartWithLinesComponent,
    TransportationHighlightWrapperComponent,
    TransportationHighlightsComponent,
    SingleApiHighlightsComponent,
    WhpHighlightWrapperComponent,
    InventoryHighlightComponent,
    HighlightBlockComponent,
    WidgetSimpleColumnChartComponent,
    WidgetSlaGraphComponent
    
  ],

  providers: [
    DynamicPipe,
    DecimalPipe

    // { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
    //{ provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        ErrorService,
        LoggingService,
        LocalStorageService,
        GenericHttpService,
        PermissionUrlService,
        PermissionGuardService,
        DropDownService,
        GenericUtils,
        CommonService,
        FilterWrapperService,
        MessageService,
        DynamicPipe,
        DecimalPipe
      ]
    };
  }
}
